import React, {useCallback, useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {createMessage, getMessages} from "../../../../redux/actions/kbExchangeActions";
import UserIcon from "../../../../assets/icons/profile.svg";
import {Link} from "react-router-dom";
import TimeIcon from "../../../../assets/icons/time.svg";
import moment from "moment";
import {kbStatus, kbTypes} from "../../../../helpers/data-constants";
import {getListUsers} from "../../../../redux/actions/userAction";
import CrossIcon from "../../../../assets/icons/cross.svg";
import Highlight from "react-highlight";
import ReactModal from "react-modal";
import format from "xml-formatter";
import {ActionButton, ConfirmModal} from "../../../common";
import {kbService} from "../../../../services/kb-exchange-service";
import ContentLoader from "react-content-loader";


const KBMessages = ({dealId}) => {
    const [messages, setMessages] = useState([]);
    const [xmlModal, setXmlModal] = useState(false);
    const [resendModal, setResendModal] = useState(false);
    const [resendMessage, setResendMessage] = useState(undefined);
    const [xml, setXml] = useState(undefined);
    const [xmlLoading, setXmlLoading] = useState(false);

    const {isLoading, commonError: commonErrorKB, messages: kbMessages, totalElements,createdFlag} = useSelector(({kb}) => kb);
    const {listUsers, isLoading: isLoadingUsers} = useSelector(({user}) => user);
    const dispatch = useDispatch();

    useEffect(() => {
      const data = {
        size: 200,
        page: 1,
        descending: true,
        filters: {
          dealId: '' + dealId
        }
      }
      dispatch(getMessages(data));
    }, [dealId, dispatch,createdFlag]);

    useEffect(() => {
      if (kbMessages && kbMessages.length !== 0) {
        let userIds = Array.from(new Set(kbMessages.filter(({userId}) => userId !== -1).map(({userId}) => userId))).join(',');
        dispatch(getListUsers(userIds));
      }

    }, [kbMessages, dispatch]);

    useEffect(() => {
      if (kbMessages) {
        let usersMap = {};
        if (listUsers) {
          listUsers.forEach((user) => {
            usersMap[user.id] = user;
          })
        }

        let message = kbMessages.map((kbMessage) => {
          if (usersMap[kbMessage.userId]) {
            kbMessage.userFullName = usersMap[kbMessage.userId].fullName;
          }
          return kbMessage;
        })
        setMessages(message);
      }
    }, [kbMessages, listUsers]);

    const getForamattedXml = (base64) => {
      let xml = decodeURIComponent(atob(base64).split('').map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      }).join(''))
      return format(xml, {
        indentation: '  ',
        filter: (node) => node.type !== 'Comment',
        collapseContent: true,
        lineSeparator: '\n'
      });
    }

    const loadXML = (messageId) => {
      setXmlLoading(true)
      setXmlModal(true)

      kbService.getMessage(messageId)
        .then(({data}) => {
          setXml(data.details.xml)
        })
        .catch((err) => {
        })
        .finally(() => {
          setXmlLoading(false)
        })
    }

    const resend = () => {
      setResendModal(false);
      let res = resendMessage;
      setResendMessage(undefined)
      dispatch(createMessage({
        type: res.type,
        dealId: res.dealId,
        repeat: res.id
      }));

    }

    return (
      <fieldset className="m-t-spacer-2">
        <div className="contracts-timeline">
          {messages && messages.length > 0 &&
          messages.map((message, index) =>
              <div key={'msg' + index} className="contracts-timeline-item">
                <div className="contracts-timeline-item-header">
                  <div className="contracts-timeline-item-header-left">
             <span
               className={"label " + kbStatus[message.status].label}>{kbStatus[message.status].text}</span>
                  </div>
                  <div className="contracts-timeline-item-user">
                    <span className="icon">
                      <UserIcon/>
                    </span>
                    <Link className="link" to={`/user/${message.userId}`}>
                      <span>{message.userFullName}</span>
                    </Link>
                  </div>
                  <div className="contracts-timeline-item-header-right">
                     <span
                       className={"label"}>{message.code}</span>
                  </div>
                  <div className="contracts-timeline-item-datetime">
          <span className="icon">
            <TimeIcon/>
          </span>
                    <span>{moment(message.time).format('DD.MM.YYYY, HH:mm:ss')}</span>
                  </div>
                </div>
                <div className="contracts-timeline-item-content">
                  <div className="contracts-timeline-item-content-left">
                    <ul className="contracts-timeline-list">
                      <li>
                        <p>{kbTypes[message.type || "UNKNOWN"] || kbTypes["UNKNOWN"]}</p>
                      </li>
                      {message.status === 'ERROR' && <li>
                        <p>Код: {message.responseCode}, Сообщение: {message.responseMessage}</p>
                      </li>}

                    </ul>

                  </div>
                  <div className="contracts-timeline-item-content-right">
                    <div className="action-items">
                      <ActionButton text="Просмотр" func={loadXML} param={message.id}/>
                      <ActionButton text="Повтор" func={() => {
                        setResendModal(true)
                        setResendMessage(message)
                      }} />

                      <ConfirmModal
                        isOpen={resendModal}
                        handleClose={() => {
                          setResendModal(false)
                          setResendMessage(undefined)
                        }}
                        handleAction={() => {
                          resend()
                        }}
                        headerText="Повтор"
                        bodyText={"Повторить операцию?"}
                      />
                    </div>
                  </div>
                </div>
                {xmlModal && <ReactModal
                  isOpen={xmlModal}
                  contentLabel="Modal"
                  className="modal-container exchange-modal"
                  overlayClassName="modal-overlay"
                >
                  <div className="modal-header">
                    <h2>Просмотр содержания сообщения </h2>
                    <button className="button-icontrigger modal-closetrigger" onClick={() => {
                      setXmlModal(false)
                    }}>
                                  <span className="icon">
                                    <CrossIcon/>
                                  </span>
                    </button>
                  </div>
                  <div className="modal-body">
                    {xmlLoading ? <ContentLoader
                        speed={2}
                        width={600}
                        height={400}
                        viewBox='0 0 600 400'
                        backgroundColor='#f3f3f3'
                        foregroundColor='#ecebeb'
                      >
                        <rect x='15' y='80' rx='3' ry='3' width='150' height='20'/>
                        <rect x='190' y='150' rx='3' ry='3' width='150' height='20'/>
                        <rect x='390' y='250' rx='3' ry='3' width='150' height='20'/>
                      </ContentLoader>
                      : <Highlight className='language-xml'>
                        {xml && getForamattedXml(xml)}
                      </Highlight>

                    }

                  </div>
                </ReactModal>}

              </div>
          )}


        </div>
      </fieldset>)
  }
;

export default KBMessages;
